/**
 * Init Element queries
 */
// const ElementQueries = require('css-element-queries/src/ElementQueries');
// ElementQueries.listen();

/**
 * Init data methods
 */
const EA = {
    Methods: {},
    loadMethod (methodName, context) {
        try {
            const method = methodName.split('(');
            let payload;
            if (method.length > 1) {
                const rawPayload = method[1].slice(0, method[1].length - 1);
                if (rawPayload.length > 0) {
                    payload = JSON.parse(rawPayload);
                }
            }
            new EA.Methods[method[0]](context, payload);
        } catch (e) {
            console.error(methodName, e);
        }
    },
    loadMethods () {
        const elems = document.querySelectorAll('*[data-method]');
        elems.forEach(el => {
            const methods = el.getAttribute('data-method').split('|');
            methods.forEach(method => this.loadMethod(method.trim(), el));
        });
    }
};
export default EA;


/* eslint-disable import/first */
// import 'helpers/closest';
import 'helpers/object-fit-polyfill';
import 'helpers/ua-parser';
